module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_f_normal.9661c052.png";